// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_K-dQz","links":"index_links_veUU-","divider":"index_divider_LztjM","span":"index_span_9jeor"};